import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { isPhone, SCREEN_PADDING_HORIZONTAL } from '@helpers';
import { DashboardResultType } from '@api/domain/types';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

import DashboardLegend from '@v2/pages/dashboard/common/components/DashboardLegend';
import DashboardList from '@v2/pages/dashboard/common/components/DashboardList';
import DashboardSummary from '@v2/pages/dashboard/common/components/DashboardSummary';

import DashboardShowAllHeader from './components/DashboardShowAllHeader';
import { useDashboardShowAllViewModel } from './hooks/useDashboardShowAllViewModel';
import { SHOW_ALL_LAYOUT } from './constants';

interface DashboardShowAllProps extends WithColor {}

const DashboardShowAll: FC<DashboardShowAllProps> = ({ C }) => {
  const { scope, resultType, orderBy, from, to, pageNumber, overall, overallLoading, list, onRowPress, topOffset } = useDashboardShowAllViewModel();

  const isDiverging = resultType !== DashboardResultType.Actual;

  return (
    <View
      testID={TEST_IDS.dashboardShowAll.screen}
      style={{
        flex: 1,
        marginTop: scale(topOffset),
        paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL),
        backgroundColor: C('Background/Light/Modal'),
      }}
    >
      <DashboardShowAllHeader
        containerStyle={{ marginBottom: scale(isPhone ? SHOW_ALL_LAYOUT.header.marginVerticalMobile : SHOW_ALL_LAYOUT.header.marginBottom) }}
      />

      {isDiverging && <DashboardLegend testID={TEST_IDS.dashboardShowAll.list.legend} />}

      <DashboardList
        scope={scope}
        resultType={resultType}
        orderBy={orderBy}
        from={from}
        to={to}
        items={list.items}
        loading={list.loading}
        error={list.error}
        pageNumber={pageNumber}
        onLoadMore={list.loadNext}
        onRetry={list.refetch}
        onRowPress={onRowPress}
        containerStyle={{ flex: 1, marginTop: scale(SHOW_ALL_LAYOUT.list.marginTop) }}
        testID={TEST_IDS.dashboardShowAll.list.container}
        rowTestIDForId={(id) => TEST_IDS.dashboardShowAll.list.row(id)}
        emptyTestID={TEST_IDS.dashboardShowAll.list.empty}
        errorTestID={TEST_IDS.dashboardShowAll.list.error}
        retryTestID={TEST_IDS.dashboardShowAll.list.retry}
      />

      {isDiverging && (
        <DashboardSummary
          overall={overall ?? null}
          loading={overallLoading}
          containerStyle={{ marginTop: scale(16), marginBottom: scale(16) }}
          testIDs={{
            loss: TEST_IDS.dashboardShowAll.summary.loss,
            gain: TEST_IDS.dashboardShowAll.summary.gain,
            net: TEST_IDS.dashboardShowAll.summary.net,
          }}
        />
      )}
    </View>
  );
};

export default ColorWrapper(DashboardShowAll);
